import {
  ContentLink,
  ContentLinkCreateInput,
  ContentLinkListResult,
  GovernedPendingApprovalResponse,
} from '@vivport/backend/types';
import { httpClient } from './http-client';

export async function listContentLinks(contentId: number): Promise<ContentLinkListResult> {
  return httpClient.get<ContentLinkListResult>(`/protected/content/${contentId}/links`);
}

export async function createContentLink(
  contentId: number,
  payload: ContentLinkCreateInput
): Promise<ContentLink | GovernedPendingApprovalResponse> {
  return httpClient.post<ContentLink | GovernedPendingApprovalResponse>(
    `/protected/content/${contentId}/links`,
    payload
  );
}

export async function deleteContentLink(contentId: number, targetContentId: number): Promise<void> {
  return httpClient.delete<void>(`/protected/content/${contentId}/links/${targetContentId}`);
}
